function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useMemo, useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { GlobalNav } from '@cb/components';
import { useLocaleContext, SubNav, BANNER_HEIGHT_45, BANNER_HEIGHT_0, UK_BANNER_HEIGHT, GLOBAL_HEADER_CONTAINER_Z_INDEX, GLOBAL_HEADER_BREAKPOINT_DESKTOP } from '@cbhq/cdx-components';
import { localeCodeToDisplayName, langPickerSupportedLocales } from '../globals/locales.js';
import { getProjectConfigProps } from '../globals/projectSettings.js';
import { getSiteConfigProps } from '../globals/siteSettings.js';
import { getLocaleCodeWithoutRegion, getRegionCodeFromLocale } from '../utils/splitLocale.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
function Header({
  isMobile,
  projectConfig,
  siteConfig,
  path,
  onSearch,
  banner,
  userLocaleInfo,
  localeInformation
}) {
  const _useMemo = useMemo(() => getProjectConfigProps(projectConfig, path), [projectConfig, path]),
    productName = _useMemo.productName,
    _useMemo$productUrl = _useMemo.productUrl,
    productUrl = _useMemo$productUrl === void 0 ? '' : _useMemo$productUrl,
    subNavLinks = _useMemo.subNavLinks,
    hasSearch = _useMemo.hasSearch,
    searchTags = _useMemo.searchTags,
    secondaryCtaUrl = _useMemo.secondaryCtaUrl,
    primaryCtaUrl = _useMemo.primaryCtaUrl,
    primaryCtaLabel = _useMemo.primaryCtaLabel,
    navbarStyleOverride = _useMemo.navbarStyleOverride,
    secondaryLogoHref = _useMemo.secondaryLogoHref,
    subNavSecondaryLink = _useMemo.subNavSecondaryLink;
  const _useMemo2 = useMemo(() => getSiteConfigProps(siteConfig), [siteConfig]),
    navbar = _useMemo2.navbar;
  const _useIntl = useIntl(),
    messages = _useIntl.messages,
    intlLocale = _useIntl.locale;
  const _useLocaleContext = useLocaleContext(),
    locale = _useLocaleContext.locale,
    defaultLoggedOutConfig = _useLocaleContext.defaultLoggedOutConfig,
    fallbackLoggedOutConfig = _useLocaleContext.fallbackLoggedOutConfig;
  const countryFromIp = Cookies.get('ip_country')?.toUpperCase() || 'US';
  const localeCode = getLocaleCodeWithoutRegion(locale);
  const countryFromUrl = getRegionCodeFromLocale(locale, defaultLoggedOutConfig, fallbackLoggedOutConfig);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [navbar && /*#__PURE__*/jsx(GlobalNav, {
      userLocaleInfo: _objectSpread(_objectSpread({}, userLocaleInfo), {}, {
        localeCode: locale,
        countryFromUrl,
        countryFromIp,
        languageCode: localeCode,
        localeFromUrl: locale
      }),
      initIsMobile: isMobile,
      localeInformation: _objectSpread(_objectSpread({}, localeInformation), {}, {
        selectedLocaleCode: localeCode
      }),
      useRelativeLinks: true,
      themeMode: navbarStyleOverride || navbar.style,
      subNavLinks: !hasSearch && subNavLinks.length > 0 ? subNavLinks : undefined,
      useNewLogo: true,
      mainCTA: {
        url: primaryCtaUrl,
        label: primaryCtaLabel
      },
      secondaryCTA: {
        url: secondaryCtaUrl,
        label: navbar.secondaryCtaLabel
      },
      signInUrl: secondaryCtaUrl || navbar.secondaryCtaUrl,
      signUpUrl: primaryCtaUrl || navbar.primaryCtaUrl,
      productName: !hasSearch && productUrl ? productName : undefined,
      productUrl: !hasSearch ? productUrl : undefined,
      banner: banner,
      customLogoUrl: secondaryLogoHref,
      locale: intlLocale,
      messages: messages,
      isGlobalPreferencesEnabled: true,
      isCountrySwitchBannerEnabled: true,
      subNavSecondaryLink: subNavSecondaryLink
    }, userLocaleInfo?.countryFromIp), hasSearch && /*#__PURE__*/jsx(SubNav, {
      productName: productName,
      productUrl: productUrl,
      subNavLinks: subNavLinks,
      hasSearch: hasSearch,
      searchTags: searchTags,
      onSearch: onSearch,
      hasBanner: !!banner
    })]
  });
}
function ResponsiveHeader(props) {
  const projectConfig = props.projectConfig,
    siteConfig = props.siteConfig,
    path = props.path;
  const _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    banner = _useState2[0],
    setBanner = _useState2[1];
  const _useState3 = useState(BANNER_HEIGHT_45),
    _useState4 = _slicedToArray(_useState3, 2),
    bannerHeight = _useState4[0],
    setBannerHeight = _useState4[1];
  const _useState5 = useState({
      countryFromIp: ''
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    userLocaleInfo = _useState6[0],
    setUserLocaleInfo = _useState6[1];
  const ipCountryFromCookie = Cookies.get('ip_country')?.toUpperCase();
  useEffect(() => {
    const _getProjectConfigProp = getProjectConfigProps(projectConfig, path),
      projectSettingsBanner = _getProjectConfigProp.banner;
    const _getSiteConfigProps = getSiteConfigProps(siteConfig),
      siteSettingsBanner = _getSiteConfigProps.banner;
    const bannerFromSettings = projectSettingsBanner || siteSettingsBanner;
    if (ipCountryFromCookie === 'GB') {
      setUserLocaleInfo({
        countryFromIp: 'GB'
      });
    }
    setBanner(bannerFromSettings);
    setBannerHeight(bannerFromSettings || ipCountryFromCookie === 'GB' ? BANNER_HEIGHT_0 : BANNER_HEIGHT_45);
  }, [path, ipCountryFromCookie, projectConfig, siteConfig]);
  return /*#__PURE__*/jsx(Fragment, {
    children: [false, true].map((isMobile, index) => /*#__PURE__*/jsx(LayoutHeader, {
      bannerHeight: isMobile && ipCountryFromCookie === 'GB' && bannerHeight === BANNER_HEIGHT_45 ? UK_BANNER_HEIGHT : bannerHeight,
      isMobile: isMobile,
      children: /*#__PURE__*/jsx(Header, _objectSpread(_objectSpread({}, props), {}, {
        isMobile: isMobile,
        banner: banner,
        userLocaleInfo: _objectSpread({}, userLocaleInfo),
        localeInformation: {
          selectedLocaleCode: '',
          localeCodeToDisplayName,
          supportedLocales: langPickerSupportedLocales
        }
      }))
    }, index))
  });
}
const LayoutHeader = styled.div.withConfig({
  shouldForwardProp: p => !['isMobile'].includes(p)
}).attrs(p => ({
  style: {
    '--header-banner-height': `${p.bannerHeight}px`
  }
}))`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  position: sticky;
  z-index: ${GLOBAL_HEADER_CONTAINER_Z_INDEX};
  top: 0;

  & > div:first-child {
    position: unset;
    height: var(--header-banner-height);
  }

  & > header {
    position: unset;
    height: auto;

    & > nav a,
    nav span {
      position: static;
    }
  }

  display: none;
  @media ${props => props.isMobile ? `(max-width: ${GLOBAL_HEADER_BREAKPOINT_DESKTOP}px)` : `(min-width: ${GLOBAL_HEADER_BREAKPOINT_DESKTOP}px)`} {
    width: 100%;
    display: flex;
  }
`;
export { ResponsiveHeader };
//# sourceMappingURL=Header.js.map
